const TreasureChestIcon = ({ className = '', opening = false }) => (
  <svg
    className={`coreboundTreasureChestIcon ${
      opening ? 'is-opening' : ''
    } ${className}`.trim()}
    viewBox="0 0 32 32"
    role="img"
    aria-label="Treasure chest"
  >
    <path d="M4 13h24v15H4z" fill="#9d5428" stroke="#ffe18a" strokeWidth="2" />
    <path className="coreboundChestLight" d="M5 15 -2 -3h36L27 15z" />
    <g className="coreboundChestLid">
      <path
        d="M3 12a5 5 0 0 1 5-5h16a5 5 0 0 1 5 5v3H3z"
        fill="#c77a35"
        stroke="#ffe18a"
        strokeWidth="2"
      />
      <path d="M10 8v7m12-7v7" fill="none" stroke="#ffe18a" strokeWidth="2" />
    </g>
    <path d="M4 17h24" fill="none" stroke="#ffe18a" strokeWidth="2" />
    <path d="M14 19h4v6h-4z" fill="#fff0a1" stroke="#ffe18a" strokeWidth="1" />
  </svg>
);

export default TreasureChestIcon;
